var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-content',{scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('hero-header',{attrs:{"heading":"Terms & Conditions"}})]},proxy:true}])},[_c('p',[_vm._v("\n    TBC\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }